import React from 'react';
import ServicesSection from "./ServiceSection";
import HeroSection from "./HeroSection";
import CalendarEvents from './CalendarEvents';

function Home() {
    return (
        <>
            <HeroSection />
            <ServicesSection />
            <CalendarEvents />
        </>
    );
}

export default Home;
